import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from '../index.module.scss';
import isEmpty from 'lodash/isEmpty';
import PanelHeaderBar from 'components/PanelHeaderBar';
import { PANEL_SECTION_HEADER } from 'utils/constants/index';
import Section from 'components/Section';
import DetailGeneralInfo from 'components/DetailGeneralInfo';
import {
  fetchBillingInfo,
  fetchSecurityCompanyDetail,
  getSecurityCompanyBillingInfo,
  getSecurityCompanyDetail,
  getSecurityCompanyId,
} from 'reducers/securityCompany';
import { getCompanyProfileData } from 'utils/DataTransform/SecurityCompanies/securityCompanyAccountInfo';
import { modalState, toggleModal } from 'reducers/ui';
import CompanyProfileForm from './accountForm';

const AccountInfo = ({
  securityCompanyProfile,
  securityCompanyImage,
  showEditCompany,
  toggleModal,
}) => {
  const toggleEditCompany = () => {
    toggleModal(!showEditCompany);
  };

  return (
    <>
      <div className={styles.infoPanel}>
        <PanelHeaderBar title={PANEL_SECTION_HEADER.ACCOUNT_INFO} />
        {!isEmpty(securityCompanyProfile) && (
          <Section
            text="Company Profile"
            expandable={false}
            editable={true}
            onEdit={toggleEditCompany}
          >
            <DetailGeneralInfo
              imageSrc={{ value: securityCompanyImage }}
              data={securityCompanyProfile}
            />
          </Section>
        )}
      </div>
      {showEditCompany && <CompanyProfileForm close={toggleEditCompany} />}
    </>
  );
};
AccountInfo.propTypes = {
  securityCompanyProfile: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
  securityCompanyBillingInfo: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
  securityCompanyBillingInfoRaw: PropTypes.object,
  securityCompanyImage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  showEditCompany: PropTypes.bool,
  toggleModal: PropTypes.func,
  fetchBillingInfo: PropTypes.func,
  companyId: PropTypes.string,
  fetchCompanyDetails: PropTypes.func,
  securityCompanyDetail: PropTypes.object,
};

const mapStateToProps = state => ({
  securityCompanyProfile:
    !isEmpty(getSecurityCompanyDetail(state).id) &&
    getCompanyProfileData(getSecurityCompanyDetail(state)),
  securityCompanyDetail: getSecurityCompanyDetail(state),
  securityCompanyBillingInfo: getSecurityCompanyBillingInfo(state),
  securityCompanyImage:
    !isEmpty(getSecurityCompanyDetail(state)) &&
    getSecurityCompanyDetail(state).imageUrl,
  showEditCompany: modalState(state).securityCompany,
  companyId: getSecurityCompanyId(state),
});

const mapDispatchToProps = dispatch => ({
  toggleModal: () => dispatch(toggleModal('securityCompany')),
  fetchBillingInfo: () => dispatch(fetchBillingInfo()),
  fetchCompanyDetails: id => dispatch(fetchSecurityCompanyDetail(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountInfo);
